export default __webpack_public_path__ + "static/media/lightbulb.4cdcc9bc.svg";